import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";

import MEliminarProductoProduccion from "@ProductosProduccion/Modales/MEliminarProductoProduccion";
import MDetalleInferiorProductoProduccion from "@ProductosProduccion/Modales/MDetalleInferiorProductoProduccion";
import MAgregarEditarProductoProduccion from "@ProductosProduccion/Modales/MAgregarEditarProductoProduccion";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import * as _testing_ from "@Funciones/testing";
import "./ProductosProduccion.css";

function ProductosProduccion() {
  const origenComponente = "ProductosProduccion";
  const { ecv_u, cv_u, usuarioSesion, esComputadora } = useContext(Contexto);
  const [recargaComponente, erecargaComponente] = useState(false);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });

  const [v_u, ev_u] = useState({
    //TABLA
    do_datosTabla: {},
    do_filtros: [],
    do_filtrosActualizados: {},
    da_grid: [],
    da_headgrid: [],
    d_multiselecion: false,
    do_seleccionados: {},

    //DATOS USUARIO
    v_formulario: false,
    da_maestros: [],
    d_codigoMaestro: null,
    d_actualizarTabla: false,
  
    //ESTADO PROCESAOR API
    i_procesandoApi: false,
    i_primeraCarga: true,
  });

  useEffect(() => {
    const maestrosAPI = _api_.f_listarMaestros({
      parametros: { empresa: null, activo: "S" },
      origen: origenComponente,
      timeout: 5000,
    });
    maestrosAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      if (!dPC.error) {
        _f_.asignar(ev_u, { da_maestros: dPC.contenido.maestro });
      }
    });

    const listaProductosMaestroAPI = _api_.f_listaProductoMaestro({
      parametros: { maestro: v_u.d_codigoMaestro, activo: null, categoria: "S", extenso: "S", todo: "S" },
      origen: origenComponente,
      timeout: 5000,
    });
    listaProductosMaestroAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          do_datosTabla: dPC.contenido,
          do_filtros: dPC.contenido.filtros,
          da_grid: dPC.contenido.grid,
          da_headgrid: dPC.contenido.headgrid,
          d_multiselecion: dPC.contenido.multiseleccion,
        });
      }
    });
  }, [v_u.d_actualizarTabla, recargaComponente,v_u.d_codigoMaestro]);

  return (
    <div className="productosProduccionCSS-contenedor">
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, { modal_mostrar: false });
          }}>
          <MAgregarEditarProductoProduccion
            origenComponente
            registro={{
              codigo: 0,
            }}
            fCerrarComponente={() => {
              _f_.asignar(ev_c, { modal_mostrar: false });
            }}
            fActualizarTablaTotal={(actualizar) => {
              if (actualizar) {
                erecargaComponente((prev) => !prev);
              }
            }}
          />
        </ModalInformacion>
      )}
      <div className="titulo-componente">{"Productos de Producción"}</div>

      <div className="productosProduccionCSS-cabecera">
        <_opt_.Opcion2
          texto="Maestros"
          clave={["usuario"]}
          valor={["nombre", "apellido_paterno", "apellido_materno"]}
          opciones={v_u.da_maestros || []}
          name={"wefwfwefwef"}
          estilos={{ flexGrow: 0, width: "100%" }}
          seleccionado={""}
          onBlur={(evento) => {
            console.log(evento.target.getAttribute("value"));
            console.log(evento.target.value);
            _f_.asignar(ev_u,{d_codigoMaestro:evento.target.getAttribute("value")})
          }}
        />
      </div>
      <div className="productosProduccionCSS-filtros">
        <Filtros
          filtros={v_u.do_filtros}
          funcionObtenerValores={(valores) => {
            _f_.asignar(ev_u, { do_filtrosActualizados: valores });
          }}
        />
      </div>
      <div className="productosProduccionCSS-cuerpo">
        <_tabla_.Tabla
          origenComponente={origenComponente}
          cabecera={v_u.da_headgrid}
          registros={v_u.da_grid}
          filtros={v_u.do_filtrosActualizados}
          modoVista={"modo2"}
          permiteMultiseleccion={v_u.d_multiselecion}
          permiteOpciones={true}
          camposCodigosSeleccion={["codigo"]}
          campoCodigoCategoria={"categoria"}
          campoCodigoRegistrosPorCategoria={"registros"}
          campoCodigoDespliegaDetalleRegistro={"codigo"}
          permiteDespliegueInferiorPorRegistro={true}
          reglasDeEstadoRegistros={v_u.do_datosTabla.reglasDeEstadoRegistros}
          mapaDeComponentes={{
            MEliminarProductoProduccion,
            MDetalleInferiorProductoProduccion,
            MAgregarEditarProductoProduccion,
          }}
          fNotificarActualizacionDeTabla={(actualizar) => {
            if (actualizar) {
              _f_.asignar(ev_u, { d_actualizarTabla: !v_u.d_actualizarTabla });
              erecargaComponente((prev) => !prev);
            }
          }}
        />
      </div>
      <div className="productosProduccionCSS-opciones">
        <_btn_.Boton
          texto={`Agregar Producto Producción`}
          tipo="btn-2"
          estilos={{
            anchoB2: "10rem",
            color: "var(--color_verde_1)",
            fuente: "1rem",
          }}
          onClick={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_titulo: "Agregar Producto Producción",
              modal_estilos: { anchoMI: "40rem", altoMI: "initial" },
            });
          }}
        />
      </div>
    </div>
  );
}

export default ProductosProduccion;
